"use client";

import { useInstrumentation } from "@/providers/Observability.provider";
import { useCallback, useRef } from "react";

import { neutralizeScripts } from "../../helpers/neutralizeScripts.helper";
import { useAutoplayCmsMedia } from "../../hooks/useAutoplayCmsMedia.hook";
import {
  CmsDomReadyListenerFailure,
  useReplayCmsScripts,
} from "../../hooks/useReplayCmsScripts.hook";

type Props = {
  content: string;
  className?: string;
  dataCmsKey?: string;
};

export function CmsContent({
  content,
  className = "cms-content",
  dataCmsKey,
}: Readonly<Props>) {
  const ref = useRef<HTMLDivElement>(null);
  const safeHtml = neutralizeScripts(content);

  const instrumentation = useInstrumentation();
  const reportListenerFailure = useCallback(
    ({ cmsKey, eventName, error }: CmsDomReadyListenerFailure) => {
      instrumentation?.captureError(error, {
        cmsKey,
        eventName,
        feature: "cms-dom-ready-replay",
      });
    },
    [instrumentation],
  );

  useReplayCmsScripts(ref, safeHtml, dataCmsKey, reportListenerFailure);
  useAutoplayCmsMedia(ref, safeHtml);

  return (
    <div
      ref={ref}
      className={className}
      data-cms-key={dataCmsKey}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
      suppressHydrationWarning
    />
  );
}
